import { useState } from 'react';
import { API_URL } from '../utils/constant';


/** Creates a replacer function to handle circular references in objects during JSON stringification.
 * It uses a `WeakSet` to track seen objects and replaces circular references with a string.
 *
 * @returns {function(string, any): any} A function to be used in JSON.stringify to handle circular references.
 */
const circularReferenceReplacer = () => {
    const seen = new WeakSet();
    return (key, value) => {
        const isCircularReference = Boolean(typeof value === 'object' && value !== null);
        if(isCircularReference){
            if(seen.has(value)){
                // Return a placeholder for circular references.
                return '[Circular Reference]';
            }
            seen.add(value);
        }
        // Return the original value if it's not a circular reference.
        return value;
    };
};


/** Custom React hook for sending HTTP requests with loading and error handling.
 *
 * @returns {[boolean, string|null, sendHttpRequest]} - 
 * An array containing:
 *  1. loading state (`boolean`) Indicates if a request is in progress
 *  2. error message (`string|null`) Contains error message if request fails
 *  3. sendHttpRequest Function to make API calls
 */
function useHttp(){
    const [loading, setLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    /** Sends an HTTP request to the specified URL
     * 
     * @param {string} url - The endpoint URL (will be appended to API_URL)
     * @param {string} method - The HTTP method to use
     * @param {object} body - The request body (will be stringified to JSON)
     * @param {Function} action - Callback function to handle the response data
     * @returns {Promise} The fetch promise
     */
    async function sendHttpRequest(url, method, body, action){
        setLoading(true);
        const endPoint = `${API_URL}/${url}`;
        console.log(endPoint);
        
        const headers = {
            'Content-Type': 'application/json',  // assumes all api calls made with use http will have json content/bodies
            'Access-Control-Allow-Origin': '*',
            Authorization: process.env.REACT_APP_API_KEY
        };

        const promisedResponse = fetch(endPoint, {
            method: method,
            headers: headers,
            body: body ? JSON.stringify(body, circularReferenceReplacer()) : null,
        }).then(async (response) => {
            // setLoading(false);
            // if(response.status !== 200){
            //     throw new Error('Something went wrong. Please try again later');
            // }else{
            //     setLoading(false);
            //     let data = response.json();
            //     action(data);
            // }
            // setLoading(false);
            let data = await response.json();
            setLoading(false);
            action(data);
        }).catch((error) => {
            console.error(error);
            setErrorMessage(error);
        });
        return promisedResponse;
    };
    return [loading, errorMessage, sendHttpRequest];
};

export default useHttp;